var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ma-0 pa-0"},[_c('v-container',{staticClass:"bottom"},[_c('v-row',[_c('CaptionCard',{attrs:{"theme":_vm.theme,"caption":_vm.caption}})],1)],1),_c('v-container',{staticClass:"top"},[_c('TitleCard',{attrs:{"title":_vm.title}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }